import React from 'react';
import fileExtension from 'file-extension';
import uuidv4 from 'uuid/v4';

import { copyUrlToClipboard, createAppUrl } from '../utils';

const KNOWN_FILE_TYPES = ['aac', 'doc', 'html', 'json', 'mp4', 'ppt', 'tar', 'txt', 'ai', 'docx', 'java', 'key', 'otf', 'pptx', 'tgz', 'webm', 'avi', 'epub', 'm4a', 'pdf', 'psd', 'tif', 'xls', 'css', 'mov', 'php', 'rar', 'tiff', 'xmal', 'csv', 'js', 'mp3', 'sketch', 'ttf', 'zip', 'jpg', 'jpeg', 'png', 'gif'];
const DEFAULT_FILE_TYPE = 'generic-file';

export const getBase64FromFile = file => {
    const reader = new FileReader();

    return new Promise(resolve => {
        reader.onload = function (e) {
            resolve(e.target.result);
        }

        reader.readAsDataURL(file);
    });
}

export const getBase64FromFiles = async files => Promise.all(files.map(getBase64FromFile));

export const uploadFiles = fileObjects => uploadFiles(fileObjects);

export const processFile = (file, withId) => {
    return getBase64FromFile(file)
        .then(response => ({
            name: file.name.replace(/([^a-zA-Z0-9.])/g, '_'),
            contentLength: file.size,
            contentType: file.type || 'application/octet-stream',
            base64: response,
            file,
            id: withId ? uuidv4() : file.id
        }));
}

export const getFileExtension = filename => {
    return fileExtension(filename);
}

export const getFileIconElement = filename => {
    if (KNOWN_FILE_TYPES.includes(getFileExtension(filename))) {
        return <i className={`icon-file-type-${getFileExtension(filename)}`} />;
    }

    return <i className={`icon-file-type-${DEFAULT_FILE_TYPE}`} />;
}

export const copyFileUrlToClipboard = fileId => {
    copyUrlToClipboard(`${createAppUrl()}/files/${fileId}`);
}
